import { createStyles, makeStyles } from '@material-ui/styles';
import { ITheme } from 'theme/types';

const useStyles = makeStyles((theme: ITheme) =>
  createStyles({
    section: {
      marginBottom: theme.spacing(3),
    },
  })
);

export default useStyles;
